import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
// 引入vant
import Vant from 'vant'
import vantToast from './components/vant-toast.js';
import 'vant/lib/index.css'
import 'amfe-flexible'
// import { checkIOSDevice } from './utils/deviceCheck';
// // 第一步：执行 iOS 设备检测（优先于页面挂载）
// checkIOSDevice();

Vue.use(Vant)
Vue.use(vantToast);

Vue.config.productionTip = false

new Vue({
	router,
	store,
  render: h => h(App),
}).$mount('#app')
